import React from "react";
import { Card, Form, Input, Button, Typography, Space } from "antd";
import { useLogin } from "@refinedev/core";

const LoginPage: React.FC = () => {
  const { mutateAsync: login } = useLogin();

  const onFinish = async (values: any) => {
    await login({ email: values.email, password: values.password });
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
      <Card style={{ width: 360 }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Typography.Title level={4} style={{ marginBottom: 0 }}>Вход</Typography.Title>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item name="email" label="Email" rules={[{ required: true, message: "Введите email" }]}>
              <Input placeholder="admin@art-visage.ru" />
            </Form.Item>
            <Form.Item name="password" label="Пароль" rules={[{ required: true, message: "Введите пароль" }]}>
              <Input.Password placeholder="••••••••" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>Войти</Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;

